<div class="container">
    <div class="row">
        <div class="col-md-12">
            <h1>
                <i class="fa fa-money" aria-hidden="true"></i> Chiffre
                d’affaires produits
            </h1>
        </div>
    </div>
    <div class="row" style="margin-bottom: 30px">
        <h3 style="margin-top: 0">
            entre le
            <input type="date" class="form-control" id="fromDate" required #name="ngModel" name="fromDate"
                [(ngModel)]="fromDate" style="width: 150px;display: inline;" />
            et le
            <input type="date" class="form-control" id="toDate" required #name="ngModel" name="toDate"
                [(ngModel)]="toDate" style="width: 150px;display: inline;" />
        </h3>
        <div class="col-md-7" style="margin-top:23px; text-align: right">
            <select class="standard-margin" [(ngModel)]="dataFilter" (change)="updateStats()" style="width: 180px">
                <option value="turnover">
                    Chiffre d'affaire
                </option>
                <option value="studentCount">
                    Nombre de stagiaires
                </option>
                <option value="sessionCount">
                    Nombre de sessions
                </option>
            </select>
            &nbsp;&nbsp;&nbsp;
            <select class="standard-margin" [(ngModel)]="dataRegion" (change)="updateStats()" style="width: 180px">
                <option value="all">
                    Toutes les agences
                </option>
                <option *ngFor="let region of regions" [value]="region">
                    {{ translations[region] }}
                </option>
            </select>
            &nbsp;&nbsp;&nbsp;
            <select class="standard-margin" [(ngModel)]="dataType" (change)="updateStats()" style="width: 180px">
                <option value="all">
                    Inter et Intra
                </option>
                <option value="inter">
                    Inter
                </option>
                <option value="intra">
                    Intra
                </option>
            </select>
        </div>
    </div>
    <div>
        <div *ngIf="!displayCanvas" class="center-loading align-self-center">
            <loading></loading>
            <span>Récupération des données ...</span>
        </div>
        <div *ngIf="displayCanvas">
            <canvas baseChart [datasets]="chart.data" [labels]="chart.labels" [legend]="chart.legends"
                [options]="chart.options" [chartType]="chart.type" (chartClick)="openInfoModal($event)"
                style="display: block" height="100px"></canvas>
        </div>
    </div>

    <h5 class="text-right" *ngIf="displayCanvas">
        <b>
            <span *ngIf="dataFilter === 'turnover'">{{ total.value }} €</span>
            <span *ngIf="dataFilter === 'studentCount'">{{ total.value }} stagiaires</span>
            <span *ngIf="dataFilter === 'sessionCount'">{{ total.value }} sessions</span>
        </b>
        (différence: {{ total.delta }}
        <span *ngIf="dataFilter === 'turnover'">€</span> soit
        <span *ngIf="total.percentDelta > 0">+</span>{{ total.percentDelta }}%)
    </h5>
    <br />

    <h3>Répartition par mois</h3>

    <table class="table" *ngIf="monthArrayStatistics">
        <thead>
            <tr>
                <th></th>
                <th *ngFor="let month of months">
                    {{ formatDate(month) }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr class="active">
                <td><b>Chiffre d'affaire</b></td>
                <td *ngFor="let month of months">
                    <b>
                        <data-analysis-value [data]="monthArrayStatistics[month]" [property]="propertyPath + 'turnover'"
                            [isAmount]="true">
                        </data-analysis-value>
                    </b>
                </td>
            </tr>
            <tr>
                <td class="text-right">Inter</td>
                <td *ngFor="let month of months">
                    <data-analysis-value [data]="monthArrayStatistics[month]"
                        [property]="propertyPath + 'types.inter.turnover'" [isAmount]="true">
                    </data-analysis-value>
                </td>
            </tr>
            <tr>
                <td class="text-right">Intra</td>
                <td *ngFor="let month of months">
                    <data-analysis-value [data]="monthArrayStatistics[month]"
                        [property]="propertyPath + 'types.intra.turnover'" [isAmount]="true">
                    </data-analysis-value>
            </td>
        </tr>
        <tr>
            <td class="text-right">Inter</td>
            <td *ngFor="let month of months">
                <data-analysis-value [data]="monthArrayStatistics[month]"
                                     [property]="propertyPath + 'types.inter.sessionCount'"
                                     [isAmount]="false">
                </data-analysis-value>
            </td>
        </tr>
        <tr>
            <td class="text-right">Intra</td>
            <td *ngFor="let month of months">
                <data-analysis-value [data]="monthArrayStatistics[month]"
                                     [property]="propertyPath + 'types.intra.sessionCount'"
                                     [isAmount]="false">
                </data-analysis-value>
            </td>
        </tr>
        <tr class="active">
            <td><b>Nombre de stagiaires</b></td>
            <td *ngFor="let month of months">
                    <data-analysis-value [data]="monthArrayStatistics[month]"
                        [property]="propertyPath + 'types.intra.studentCount'" [isAmount]="false">
                    </data-analysis-value>
                </td>
            </tr>
        </tbody>
    </table>

    <h3 style="margin-top: 70px;">Totaux sur la période répartie par agence</h3>

    <table class="table" *ngIf="totalStatistics?.value">
        <thead>
            <tr>
                <th></th>
                <th *ngFor="let region of regions">
                    {{ translations[region] }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr class="active">
                <td><b>Chiffre d'affaire</b></td>
                <td *ngFor="let region of regions">
                    <b>
                        <data-analysis-value [data]="totalStatistics" [property]="'locations.' + region + '.turnover'"
                            [isAmount]="true">
                        </data-analysis-value>
                    </b>
                </td>
            </tr>
            <tr>
                <td class="text-right">Inter</td>
                <td *ngFor="let region of regions">
                    <data-analysis-value [data]="totalStatistics" [property]="
                            'locations.' + region + '.types.inter.turnover'
                        " [isAmount]="true">
                    </data-analysis-value>
                </td>
            </tr>
            <tr>
                <td class="text-right">Intra</td>
                <td *ngFor="let region of regions">
                    <data-analysis-value [data]="totalStatistics" [property]="
                            'locations.' + region + '.types.intra.turnover'
                        " [isAmount]="true">
                    </data-analysis-value>
                </td>
            </tr>
            <tr class="active">
                <td><b>Nombre de sessions</b></td>
                <td *ngFor="let region of regions">
                    <b>
                        <data-analysis-value [data]="totalStatistics"
                            [property]="'locations.' + region + '.sessionCount'" [isAmount]="false">
                        </data-analysis-value>
                    </b>
                </td>
            </tr>
            <tr>
                <td class="text-right">Inter</td>
                <td *ngFor="let region of regions">
                    <data-analysis-value [data]="totalStatistics" [property]="
                            'locations.' + region + '.types.inter.sessionCount'
                        " [isAmount]="false">
                    </data-analysis-value>
                </td>
            </tr>
            <tr>
                <td class="text-right">Intra</td>
                <td *ngFor="let region of regions">
                    <data-analysis-value [data]="totalStatistics" [property]="
                            'locations.' + region + '.types.intra.sessionCount'
                        " [isAmount]="false">
                    </data-analysis-value>
                </td>
            </tr>
            <tr class="active">
                <td><b>Nombre de stagiaires</b></td>
                <td *ngFor="let region of regions">
                    <b>
                        <data-analysis-value [data]="totalStatistics"
                            [property]="'locations.' + region + '.studentCount'" [isAmount]="false">
                        </data-analysis-value>
                    </b>
                </td>
            </tr>
            <tr>
                <td class="text-right">Inter</td>
                <td *ngFor="let region of regions">
                    <data-analysis-value [data]="totalStatistics" [property]="
                            'locations.' + region + '.types.inter.studentCount'
                        " [isAmount]="false">
                    </data-analysis-value>
                </td>
            </tr>
            <tr>
                <td class="text-right">Intra</td>
                <td *ngFor="let region of regions">
                    <data-analysis-value [data]="totalStatistics" [property]="
                            'locations.' + region + '.types.intra.studentCount'
                        " [isAmount]="false">
                    </data-analysis-value>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<data-analysis-modal #infoModal></data-analysis-modal>



// WEBPACK FOOTER //
// ./src/app/_screens/stats/floating-turnover/floating-turnover.component.html